// extracted by mini-css-extract-plugin
export default {"cnt":"QuickAccess_cnt__B3Lsv","tile":"QuickAccess_tile__aooOR","icon":"QuickAccess_icon__GaARZ","label":"QuickAccess_label__G+d93"};